import React, {Component} from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {getAMorPM, getDateFromDateString, getHours} from '../../shared/dateFormatter';

import moment from "moment";
import momentTimezone from "moment-timezone";

class ScheduleResult extends Component {

  state = {
    expansionPanelOpen: false,
    expansionText: 'View Details',
  };

  handleExpansionPanelOpening = () => {
    this.setState({
      expansionPanelOpen: !this.state.expansionPanelOpen
    });

    if (this.state.expansionText === 'View Details') {
      this.setState({expansionText: 'Hide Details'})
    }

    if (this.state.expansionText === 'Hide Details') {
      this.setState({expansionText: 'View Details'})
    }
  };

  getFlightStatusCSSCLass = (flightStatus) => {
    switch (flightStatus) {
      case 'DEPARTED':
      case 'ARRIVED':
        return 'schedule-result__flight-status--regular';
      case 'ON_TIME':
      case 'EARLY':
      case 'ARRIVING':
      case 'AT_GATE':
        return 'schedule-result__flight-status--green';
      case 'DELAYED':
        return 'schedule-result__flight-status--red';
      default:
        return 'schedule-result__flight-status--regular';
    }
  };

  getAirportString = (airportCode) => {
    if (!this.props.nonRevAndRevFacilities) {
      return "";
    }

    let location = this.props.nonRevAndRevFacilities.find(item => item.airportCodeIATA === airportCode) || "";

    if (!location || !location.facilityInfo || !location.facilityInfo.location) {
      return "";
    }

    let cityName = location.facilityInfo.location.cityName
          ? location.facilityInfo.location.cityName.replace(/\w\S*/g, (c) => c[0].toUpperCase() + c.substr(1).toLowerCase())
          : "";
    let airportName = location.airportName
          ? location.airportName.replace(/\w\S*/g, (c) => c[0].toUpperCase() + c.substr(1).toLowerCase())
          : "";
    let stateName = location.facilityInfo.location.stateName || "";

    let locationCityState = "";

    if (cityName && airportName && stateName) {
      locationCityState = cityName + " (" + airportName + "), " + stateName;
    }

    return locationCityState;
  };

  render() {

    return (
      <div className="schedule-result-container">
        <ExpansionPanel expanded={this.state.expansionPanelOpen} className="schedule-result">
          <ExpansionPanelSummary onClick={this.handleExpansionPanelOpening}
                                 className="schedule-result__summary-container">
            <div className="schedule-result__summary">
              <p className="schedule-result__number"># {this.props.flightNumber} <span
                className="schedule-result__operatedby">{this.props.operatedBy}</span>
              </p>
              <div className="schedule-result__flight-info">
                <div className="schedule-result__flight-operations-time schedule-result__flight-operations-time--start">
                  <div
                    className={"schedule-result__flight-status " + this.getFlightStatusCSSCLass(this.props.departure.status)}>
                    {this.props.departure.status.replace('_', ' ')}
                  </div>
                  <div className="schedule-result__flight-time">{this.props.departure.scheduledTime}</div>
                  <div className="schedule-result__flight-meridiem">{this.props.departure.meridiem}</div>
                  <div className="schedule-result__flight-timezone">{this.props.departure.timezone}</div>
                  <div className="schedule-result__flight-date">{this.props.departure.scheduledDate}</div>
                </div>
                <div style={{display: "flex", flexDirection: "column"}}>
                  <img
                    className={this.props.planeChange ? " schedule-result__flight-planeChange" : "schedule-result__flight-planeChange schedule-result__flight-arrow-hidden"}
                    src="./assets/ship/CargoFlightSchedules/change-planes.svg" alt=""/>
                  <img className="schedule-result__flight-arrow" src="./assets/schedule-result/arrow-right.svg" alt=""/>
                </div>
                <div className="schedule-result__flight-operations-time schedule-result__flight-operations-time--end">
                  <div
                    className={"schedule-result__flight-status " + this.getFlightStatusCSSCLass(this.props.arrival.status)}>
                    {this.props.arrival.status.replace('_', ' ')}
                  </div>
                  <div className="schedule-result__flight-time">{this.props.arrival.scheduledTime}</div>
                  <div className="schedule-result__flight-meridiem">{this.props.arrival.meridiem}</div>
                  <div className="schedule-result__flight-timezone">{this.props.arrival.timezone}</div>
                  <div className="schedule-result__flight-date">{this.props.arrival.scheduledDate}</div>
                </div>
                <div className="flight-stops-container">
                  <div className="flight-stops">
                    {
                      this.props.stops ? this.props.stops.map((stop, index) => {

                        if (index === 0) {
                          return null;
                        }

                        let stopDuration = null;

                        if (this.props.stops[index]) {
                          let durationArrivalDate = moment(this.props.stops[index - 1].scheduledArrivalDate);
                          let durationDepartureDate = moment(stop.scheduledDepartureDate);
                          stopDuration = moment.duration(durationDepartureDate.diff(durationArrivalDate));
                        }

                        switch (stop.segmentType) {
                          case 'PLANE_CHANGE':
                            return (
                              <div key={index} className="flight-stops__stop">
                                <img className="flight-stops__stop-image"
                                     src="./assets/ship/CargoFlightSchedules/change-planes.svg" alt=""/>
                                <div className="flight-stops__stop-code">{stop.origin}</div>
                                {stopDuration ?
                                  <p
                                    className="flight-stops__stop-info">{stopDuration.hours() + "h " + stopDuration.minutes() + "m"}
                                    <span className="block">stop</span>
                                  </p> : null
                                }
                              </div>
                            );
                          case 'TRUCK':
                            return (
                              <div key={index} className="flight-stops__stop">
                                <img className="flight-stops__stop-image"
                                     src="./assets/ship/CargoFlightSchedules/truck.svg"
                                     alt=""/>
                                <div className="flight-stops__stop-code">{stop.origin}</div>
                                {stopDuration ?
                                  <p
                                    className="flight-stops__stop-info">{stopDuration.hours() + "h " + stopDuration.minutes() + "m"}
                                    <span className="block">stop</span>
                                  </p> : null
                                }
                              </div>
                            );
                          case 'FLIGHT':
                            return (
                              <div key={index} className="flight-stops__stop">
                                <img className="flight-stops__stop-image"
                                     src="./assets/ship/CargoFlightSchedules/plane.svg"
                                     alt=""/>
                                <div className="flight-stops__stop-code">{stop.origin}</div>
                                {index !== 0 && stopDuration ?
                                    <p className="flight-stops__stop-info">
                                      {stopDuration.hours() + "h " + stopDuration.minutes() + "m"}
                                      <span className="block">stop</span>
                                    </p>
                                    : null
                                }
                              </div>
                            );
                          default:
                            return (
                              <div key={index} className="flight-stops__stop">
                                <div className="flight-stops__stop-image"></div>
                                <div className="flight-stops__stop-code">{stop.origin}</div>
                                {index !== 0 && stopDuration ?
                                  <p className="flight-stops__stop-info">
                                    {stopDuration.hours() + "h " + stopDuration.minutes() + "m"}
                                    <span className="block">stop</span>
                                  </p>
                                  : null
                                }
                              </div>
                            );
                        }
                      }) : null}
                  </div>
                  <div className="flight-stops-line"></div>
                  {this.props.stops.length > 1 ? null : (
                    <p className="flight-stops__non-stop-info">Nonstop</p>
                  )}
                </div>
              </div>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className="schedule-result__details-container">
            <div className="schedule-result__details">
              {this.props.stops.map((stop, index) => {
                const noOfStops = this.props.stops.length;
                const scheduledDepartureDate = stop.scheduledDepartureDate;
                const scheduledArrivalDate = stop.scheduledArrivalDate;

                const estimatedDepartureDate = stop.estimatedDepartureDate;
                const estimatedArrivalDate = stop.estimatedArrivalDate;

                const isOriginDelayed = scheduledDepartureDate < estimatedDepartureDate;
                const isDestDelayed = scheduledArrivalDate < estimatedArrivalDate;

                const originStatus = isOriginDelayed ? "DELAYED" : "ON_TIME";
                const destStatus = isDestDelayed ? "DELAYED" : "ON_TIME";

                // destinationTimeZone
                  const destinationTimeZone = stop.destinationTimeZone && stop.destinationTimeZone.includes('/')
                          ? (() => {
                              try {
                                  return momentTimezone().tz(stop.destinationTimeZone).zoneAbbr();
                              } catch (e) {
                                  return stop.destinationTimeZone;
                              }
                          })()
                          : stop.destinationTimeZone;

                  let originTimeZone = stop.originTimeZone && stop.originTimeZone.includes('/')
                          ? (() => {
                              try {
                                  return momentTimezone().tz(stop.originTimeZone).zoneAbbr();
                              } catch (e) {
                                  return stop.originTimeZone;
                              }
                          })()
                          : stop.originTimeZone;
                let destinationLocationCityState = "";

                if (this.props.nonRevAndRevFacilities) {

                    const destination = stop.destination;

                    let destinationLocation = this.props.nonRevAndRevFacilities
                            .find(item => item.airportCodeIATA === destination);

                    if (destinationLocation && destinationLocation.facilityInfo && destinationLocation.facilityInfo.location) {
                        const cityName = destinationLocation.facilityInfo.location.cityName
                                ? destinationLocation.facilityInfo.location.cityName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase())
                                : "";
                        const stateName = destinationLocation.facilityInfo.location.stateName
                                ? destinationLocation.facilityInfo.location.stateName.replace(/\w\S*/g, c => c[0].toUpperCase() + c.substr(1).toLowerCase())
                                : "";

                        if (cityName && stateName) {
                            destinationLocationCityState = cityName + ", " + stateName;
                        }
                    }

                }

                return (
                  <div key={index} className="schedule-result__detail">
                    <div className="schedule-result__transport-info">
                      <p className="schedule-result__transport-type">{stop.segmentType}</p>
                      <p className="schedule-result__transport-number">{stop.flightNumber}</p>
                    </div>
                    <div
                      className="schedule-result__flight-operations-time schedule-result__flight-operations-time--small">
                      <div
                        className={"schedule-result__flight-status schedule-result__flight-status--small " + this.getFlightStatusCSSCLass(originStatus)}>
                        {originStatus.replace('_', ' ')}
                      </div>
                      <div
                        className="schedule-result__flight-time schedule-result__flight-time--small">{getHours(estimatedDepartureDate)}</div>
                      <div
                        className="schedule-result__flight-meridiem text-bold">{getAMorPM(estimatedDepartureDate)}</div>
                      <div className="schedule-result__flight-timezone text-bold">{originTimeZone}</div>
                      <p className="schedule-result__scheduled">scheduled</p>
                      <p className="schedule-result__time-expected">
                        <p className="color-neutral-grey-4 text-bold">
                          {getDateFromDateString(scheduledDepartureDate)}
                        </p>
                        <p className="color-neutral-grey-4 text-bold">
                          {getHours(scheduledDepartureDate)} {getAMorPM(scheduledDepartureDate)} {originTimeZone}
                        </p>
                      </p>
                    </div>
                    <div className="schedule-result__airport schedule-result__airport--departure">
                      <p className="schedule-result__airport-code">{stop.origin}</p>
                      <p className="schedule-result__airport-city">{this.getAirportString(stop.origin)}</p>
                    </div>
                    <img className="schedule-result__flight-arrow schedule-result__flight-arrow--detail"
                         src="./assets/schedule-result/arrow-right.svg" alt=""/>
                    <div
                      className="schedule-result__flight-operations-time schedule-result__flight-operations-time--small">
                      <div
                        className={"schedule-result__flight-status schedule-result__flight-status--small " + this.getFlightStatusCSSCLass(destStatus)}>
                        {destStatus.replace('_', ' ')}
                      </div>
                      <div
                        className="schedule-result__flight-time schedule-result__flight-time--small">{getHours(scheduledArrivalDate)}</div>
                      <div
                        className="schedule-result__flight-meridiem text-bold">{getAMorPM(scheduledArrivalDate)}</div>
                      <div className="schedule-result__flight-timezone text-bold">{destinationTimeZone}</div>
                      <p className="schedule-result__scheduled">scheduled</p>
                      <p className="schedule-result__time-expected">
                        <p className="color-neutral-grey-4 text-bold">
                          {getDateFromDateString(scheduledArrivalDate)}
                        </p>
                        <p className="color-neutral-grey-4 text-bold">
                          {getHours(scheduledArrivalDate)} {getAMorPM(scheduledArrivalDate)} {destinationTimeZone}
                        </p>
                      </p>
                    </div>
                    <div className="schedule-result__airport schedule-result__airport--arrival">
                      <p className="schedule-result__airport-code">{stop.destination}</p>
                      <p className="schedule-result__airport-city">{this.getAirportString(stop.destination)}</p>
                    </div>
                    {
                      index !== (noOfStops - 1) ? (
                        <div className="schedule-result__detail-separator">
                          <p className="schedule-result__detail-separator-stop-airport text-italic">1
                            stop: {destinationLocationCityState} ({stop.destination})</p>
                        </div>
                      ) : null}
                  </div>
                )
              })
              }
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <div className="schedule-result-expand-block" onClick={this.handleExpansionPanelOpening}>
          <div className="schedule-result-expand-block__text">{this.state.expansionText}</div>
          <div className="schedule-result-expand-block__icon-container">
            <ExpandMoreIcon
              className={this.state.expansionPanelOpen ? 'schedule-result-expand-block__icon schedule-result-expand-block__icon--expanded' : 'schedule-result-expand-block__icon'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ScheduleResult;



// WEBPACK FOOTER //
// ./src/components/ScheduleResult/ScheduleResult.js